import React,{useEffect, useState} from 'react'
import fire from './fire'
import {Link} from 'react-router-dom'
import { Card,Button, Row, Col, Container, Tabs, Tab } from 'react-bootstrap';
import { useCallback } from 'react';
const Compete = () =>{

    
    const [liveAndNotRegisteredcontestDetials, setLiveAndNotRegisteredcontestDetials] = useState({})
    const [registeredContests, setRegisteredContests] = useState([])
    const [endedContestsDetials, setEndedContestsDetials] = useState({})
    const [upcomingContestsDetials, setUpcomingContestsDetials] = useState({})
    const [loader, setLoader] = useState(true)

    function timeConvertor(time) {
        var PM = time.match('PM') ? true : false
        
        time = time.split(':')
        var min = time[1]
        var hour
        var sec
        if (PM) {
            hour = 12 + parseInt(time[0],10)
            sec = time[2].replace('PM', '')
        } else {
            hour = time[0]
            sec = time[2].replace('AM', '')       
        }
        
        var t = hour + ':' + min + ':' + sec
        return t
    }


    const handlerRegisteration = async(id) =>{
        setLoader(true)
        var user = await fire.auth().currentUser
        var sEmails =user.email.split("@") 
        var  use=sEmails[0].replace(/\./g,'"dot"')
        var domain=sEmails[1].replace(/\./g,'"dot"')
        var Email = ""
        Email = Email.concat(use,"@",domain) 
        Email = Email.toLowerCase()

        await fetch(`https://codezap-e156b.firebaseio.com/contests/${id}/participants/${Email}.json`,{
                    method:'PATCH',
                    headers:{
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify({
                        "score":""
                    })
                })

        loadData()
        setLoader(false)
    }

    const loadData = useCallback(async() =>{
        setLoader(true)
        
        const response = await fetch('https://codezap-e156b.firebaseio.com/contests.json')
        const resData = await response.json()
        if(resData){
            
            
            var user = await fire.auth().currentUser
            var sEmails =user.email.split("@") 
            var  use=sEmails[0].replace(/\./g,'"dot"')
            var domain=sEmails[1].replace(/\./g,'"dot"')
            var Email = ""
            Email = Email.concat(use,"@",domain) 
            Email = Email.toLowerCase()

            var liveMap = {}
            var Map = {}
            var upcomingMap = {}
            var registeredMap = {}
            for(var key in resData){
                var nowDate = new Date()
                var starttime = timeConvertor((resData[key].Start_Time)[1].split(" ").join()).replace(",","").split(":")
                var startDate = (resData[key].Start_Time)[0].replaceAll("/","-").split("-")
                var endtime = timeConvertor((resData[key].End_Time)[1].split(" ").join()).replace(",","").split(":")
                var endDate = (resData[key].End_Time)[0].replaceAll("/","-").split("-")
                var startDateTime = new Date(startDate[2],parseInt(startDate[0])-1,startDate[1],starttime[0],starttime[1],starttime[2])
                var endDateTime = new Date(endDate[2],parseInt(endDate[0])-1,endDate[1],endtime[0],endtime[1],endtime[2])
                
                if(nowDate <= endDateTime && nowDate >= startDateTime){
                    
                    if(resData[key].participants){
                        
                        if(resData[key].participants[Email]){
                            
                            registeredMap[key] = {
                                "End_Time":endDateTime,
                                "Start_Time":startDateTime,
                                "live":true
                            }    
                        }
                        else{
                            liveMap[key] = {
                                "End_Time":endDateTime,
                                "Start_Time":startDateTime,
                            }
                        }
                    }
                    else{
                        liveMap[key] = {
                            "End_Time":endDateTime,
                            "Start_Time":startDateTime,
                        }
                    }
                }
                else if(nowDate <= startDateTime){
                    if(resData[key].participants){
                        if(resData[key].participants[Email]){
                            registeredMap[key] = {
                                "End_Time":endDateTime,
                                "Start_Time":startDateTime,
                                "live":false
                            }    
                        }
                        else{
                            upcomingMap[key] = {
                                "End_Time":endDateTime,
                                "Start_Time":startDateTime,
                            }
                        }
                    }
                    else{
                        upcomingMap[key] = {
                            "End_Time":endDateTime,
                            "Start_Time":startDateTime,
                        }
                    }
                }
                else{
                    Map[key] = {
                        "End_Time":endDateTime,
                        "Start_Time":startDateTime,
                    }
                }
            }
            await setLiveAndNotRegisteredcontestDetials(liveMap)
            await setEndedContestsDetials(Map)
            await setUpcomingContestsDetials(upcomingMap)
            await setRegisteredContests(registeredMap)
            
            
        }
       

        // const response1 = await fetch(`https://codezap-e156b.firebaseio.com/participants/${Email}.json`)
        // const resData1 = await response1.json()
        // if(resData1["registered"]){
        //     await setRegisteredContests(resData1)
        // }
        setLoader(false)
    },[])

    useEffect(() =>{
        loadData()
    },[loadData])
    const [key, setKey] = useState('home');
    return(
        <section className = "hero">
            <header className="mb-4 shadow">
                <nav className="navbar navbar-dark bg-dark primary-styled-border">
                    <div className="container">
                        <h1 style={{ fontSize: '2.25rem' }}>
                            <span className="text-primary1">&lt;/&gt; </span>
                            <span style={{ color: 'white' }}>Code</span><span className="text-primary1">Zap</span>
                        </h1> 
                        
                        <div>
                        <Link to = "/">
                            <h4>Home</h4>
                        </Link>
                        </div>
                    </div>
                </nav>
            </header>    
        
        {loader ? <h1>Loading...</h1> :
            <Container style = {{marginTop:"3%"}}>

            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                style = {{backgroundColor:"#343a40"}}
                >
                <Tab eventKey="home" title="Registered">
                <br/>
            <Row>
                
                    {
                        Object.keys(registeredContests).map((item,i) => 
                            <Col sm = {4} key = {item} style = {{marginBottom:"1%"}}>
                                <Card style={{ width: '100%' }}>
                                    
                                    <Card.Body>
                                        <Card.Title style = {{fontWeight:"bold", display:"flex",justifyContent:"center"}}>{item.split("_").join(" ").substring(0, item.split("_").join(" ").length - 4)}</Card.Title>
                                        <hr/>
                                            <Card.Text style = {{display:"flex",justifyContent:"center",flexDirection:"column"}}>
                                            <div>
                                                <span><i className="fa fa-hourglass-start" style={{color: "#343a40 "}}> </i> Started on </span>
                                                {registeredContests[item]["Start_Time"].toGMTString()}
                                            </div>
                                            <div>
                                                <span><i className="fa fa-hourglass-end" style={{color: "#343a40 "}}> </i> Ends at </span>
                                                {registeredContests[item]["End_Time"].toGMTString()}
                                            </div>
                                            </Card.Text>
                                            { registeredContests[item]["live"] ?
                                                <Link to = {'/contest?UCI='+item}>
                                                    <Button style = {{backgroundColor:"#FF405F", color:"white", borderColor:"#FF405F"}}>Enter</Button>
                                                </Link>:<p></p>
                                            }
                                    </Card.Body>
                                </Card>
                            </Col>
                            )
                    }
                    
                    
            </Row>
                </Tab>
                <Tab eventKey="profile" title="Live contests">
                <br/>
            <Row>
                
                    {
                        Object.keys(liveAndNotRegisteredcontestDetials).map((item,i) => 
                            <Col sm = {4} key = {item} style = {{marginBottom:"1%"}}>
                                <Card style={{ width: '100%',  display:"flex",alignItem:"center", justifyContent:"center"}}>
                                    
                                    <Card.Body>
                                        <Card.Title style = {{fontWeight:"bold", display:"flex",justifyContent:"center"}}>{item.split("_").join(" ").substring(0, item.split("_").join(" ").length - 4)}</Card.Title>
                                        <hr/>
                                        <Card.Text style = {{display:"flex",justifyContent:"center",flexDirection:"column"}}>
                                        <div>
                                            <span><i className="fa fa-hourglass-start" style={{color: "#343a40"}}> </i> Started on </span>
                                            {liveAndNotRegisteredcontestDetials[item]["Start_Time"].toGMTString()}
                                        </div>
                                        <div>
                                            <span><i className="fa fa-hourglass-end" style={{color: "#343a40"}}> </i> Ends at </span>
                                            {liveAndNotRegisteredcontestDetials[item]["End_Time"].toGMTString()}
                                        </div>
                                        </Card.Text>
                                        <Button style = {{backgroundColor:"#FF405F", color:"white", borderColor:"#FF405F"}} onClick = {() =>handlerRegisteration(item)}>Register</Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                            )
                    }
                    
                    
            </Row>
                </Tab>
                <Tab eventKey="contact" title="Upcoming contests" >
                <br/>
            <Row>
                
                    {
                        Object.keys(upcomingContestsDetials).map((item,i) => 
                            <Col sm = {4} key = {item} style = {{marginBottom:"1%"}}>
                                <Card style={{ width: '100%' }}>
                                    
                                    <Card.Body>
                                        <Card.Title style = {{fontWeight:"bold", display:"flex",justifyContent:"center"}}>{item.split("_").join(" ").substring(0, item.split("_").join(" ").length - 4)}</Card.Title>
                                        <hr/>
                                            <Card.Text style = {{display:"flex",justifyContent:"center",flexDirection:"column"}}>
                                            <div>
                                                <span><i className="fa fa-hourglass-start" style={{color: "#343a40"}}> </i> Starts at </span>
                                                {upcomingContestsDetials[item]["Start_Time"].toGMTString()}
                                            </div>
                                            <div>
                                                <span><i className="fa fa-hourglass-end" style={{color: "#343a40"}}> </i> Ends at </span>
                                                {upcomingContestsDetials[item]["End_Time"].toGMTString()}
                                            </div>
                                            </Card.Text>
                                            <Button style = {{backgroundColor:"#FF405F", color:"white", borderColor:"#FF405F"}}onClick = {() =>handlerRegisteration(item)}>Register</Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                            )
                    }
                    
                    
            </Row>
                </Tab>
                <Tab eventKey="previous" title="Previous contests">
                <br/>
                <Row>
                    
                        {
                            Object.keys(endedContestsDetials).map((item,i) => 
                                <Col sm = {4} key = {item} style = {{marginBottom:"1%"}}>
                                    <Card style={{ width: '100%' }}>
                                        
                                        <Card.Body>
                                            <Card.Title style = {{fontWeight:"bold", display:"flex",justifyContent:"center"}}>{item.split("_").join(" ").substring(0, item.split("_").join(" ").length - 4)}</Card.Title>
                                            <hr/>
                                                <Card.Text style = {{display:"flex",justifyContent:"center",flexDirection:"column"}}>
                                                    Ended
                                                </Card.Text>
                                                <Link to = {'/Leaderboardend?UCI='+item}>
                                                    <Button style = {{backgroundColor:"#FF405F", color:"white", borderColor:"#FF405F"}}>Leaderboard</Button>
                                                </Link>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                )
                        }
                        
                        
                </Row>
                </Tab>
            </Tabs>
            
            
            </Container>
            
            }
        </section>
    )
}

export default Compete